import { Box } from '@mui/material';
import './App.css';
import LandingPage from './LandingPage';

function App() {
    return (
        <Box
            className="app"
            display='flex'
            flexDirection='column'
            zIndex={-2}
            sx={{ height: '100vh' }}
        >
            <LandingPage />
            <Box display='flex' flexDirection='column-reverse' fontFamily='Segoe UI' marginLeft={1}>
                BMSnet by Prolon Control Systems
            </Box>
        </Box>
    );
}

export default App;